import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { InstantWebsiteDataStore } from './instant-website-data.store';
import {
  fetchInstantWebsiteSettings,
  saveInstantWebsiteSettingsNetwork,
} from './instant-website.actions';
import { IInstantWebsiteSettings } from './instant-website-data.data';

@Injectable()
export class InstantWebsiteDataDispatcher {
  constructor(
    private _store: Store<any>,
    private _actions: Actions,
    private _instantWebsiteDataStore: InstantWebsiteDataStore
  ) {}

  fetchInstantWebsiteSettings() {
    this._store.dispatch(fetchInstantWebsiteSettings());
  }

  saveInstantWebsiteSettingsNetwork(settings: IInstantWebsiteSettings) {
    this._store.dispatch(saveInstantWebsiteSettingsNetwork(settings));
  }
}
